import WorkspaceSwitcherDemo from './WorkspaceSwitcherDemo';
import PlatformMapDemo from './PlatformMapDemo';
import EndToEndWorkflowDemo from './EndToEndWorkflowDemo';
import PipelineApprovalDemo from './PipelineApprovalDemo';
import ReviewPlayerDemo from './ReviewPlayerDemo';
import RevisionsDemo from './RevisionsDemo';
import TeamRolesDemo from './TeamRolesDemo';
import AgencyControlDemo from './AgencyControlDemo';

export const SHOWCASE_DEMOS = {
  workspaces: WorkspaceSwitcherDemo,
  platforms: PlatformMapDemo,
  workflow: EndToEndWorkflowDemo,
  pipeline: PipelineApprovalDemo,
  review: ReviewPlayerDemo,
  revisions: RevisionsDemo,
  team: TeamRolesDemo,
  'agency-control': AgencyControlDemo,
};
